import { Button, CircularProgress } from "@material-ui/core";

const ActionButton = ({
  classes,
  onClose,
  saveDriverPreference,
  updateInProgress,
  errorMessage,
  driverPreferenceInfo,
}) => {
  const buttonText = driverPreferenceInfo ? "Update" : "Add";
  return (
    <div className={classes.actionContainer}>
      <Button
        variant="outlined"
        color="primary"
        size="medium"
        onClick={onClose}
        classes={{ root: classes.actionButton }}
        id="closeButton"
      >
        Close
      </Button>
      <Button
        variant="contained"
        color="primary"
        size="medium"
        type="submit"
        onClick={saveDriverPreference}
        disabled={updateInProgress || errorMessage}
        classes={{
          root: classes.actionButton,
          disabled: classes.actionButtonDisabled,
        }}
      >
        {updateInProgress ? (
          <CircularProgress
            size={16}
            classes={{ root: classes.circularProgress }}
          />
        ) : (
          buttonText
        )}
      </Button>
    </div>
  );
};

export default ActionButton;
